import { Component, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentClientDialogResult } from '@core/tellent-types';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogRef,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

type FeatureDiscoveryDialogData = null;
type FeatureDiscoveryDialogResult = TellentClientDialogResult<never>;

@Component({
  selector: 'tlc-feature-discovery-dialog',
  imports: [
    DialogBodyComponent,
    IconButtonComponent,
    DialogFooterComponent,
    TranslatePipe,
    IconComponent,
    ButtonComponent,
  ],
  templateUrl: './feature-discovery-dialog.component.html',
  styleUrl: './feature-discovery-dialog.component.less',
})
export class FeatureDiscoveryDialogComponent implements DialogComponentI<
  FeatureDiscoveryDialogData,
  FeatureDiscoveryDialogResult
> {
  private readonly dialogRef = inject(DialogRef);

  public webComponentOutput: FeatureDiscoveryDialogResult;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: FeatureDiscoveryDialogData, triggerUpdate: boolean): void {}

  public close(): void {
    this.dialogRef.close();
  }

  public closeWithSuccess(): void {
    this.dialogRef.close({ success: true });
  }
}
